import script from "./commonStore.vue?vue&type=script&lang=js"
export * from "./commonStore.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__